import debounce from 'lodash.debounce';

// TODO This hook is deprecated and should be removed. It is not working.
export function useDebouncedFunction<T extends (...args: any[]) => ReturnType<T>>(
  func: T,
  delay = 100
): ReturnType<typeof debounce> {
  return debounce<T>(func, delay);
}
